import { isNative } from './platform';

let SharePlugin = null;

async function getSharePlugin() {
  if (SharePlugin) return SharePlugin;
  try {
    const mod = await import('@capacitor/share');
    SharePlugin = mod.Share;
    return SharePlugin;
  } catch {
    return null;
  }
}

export function canShare() {
  if (isNative()) return true;
  return typeof navigator !== 'undefined' && !!navigator.share;
}

/**
 * Share content using the best available method.
 * Returns { shared: boolean, method: 'native'|'web'|'clipboard'|'none' }
 */
export async function share({ title, text, url }) {
  // 1. Native Capacitor Share
  if (isNative()) {
    try {
      const plugin = await getSharePlugin();
      if (plugin) {
        await plugin.share({ title, text, url });
        return { shared: true, method: 'native' };
      }
    } catch {
      // User cancelled or plugin failed — fall through
    }
  }

  // 2. Web Share API
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return { shared: true, method: 'web' };
    } catch {
      // User cancelled — fall through
    }
  }

  // 3. Clipboard fallback
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text || url || '');
      return { shared: true, method: 'clipboard' };
    } catch {
      // Clipboard not available
    }
  }

  return { shared: false, method: 'none' };
}
